import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Teacher } from 'src/app/viewModels/teacher';
import { TeacherService } from 'src/app/apis/teacher.service';
import { EstablishmentService } from 'src/app/apis/establishment.service';
import { SettingsService } from 'src/app/apis/settings.service';
import { Day } from 'src/app/viewModels/day';
import { NotAvailableTeacher } from 'src/app/viewModels/not-available-teacher';
import { TimingService } from 'src/app/apis/timing.service';
import { Period } from 'src/app/viewModels/period';
import { EstablishmentSetting } from 'src/app/viewModels/establishment-setting';

@Component({
  selector: 'app-teacher-availibility',
  templateUrl: './teacher-availibility.component.html',
  styleUrls: ['./teacher-availibility.component.css']
})
export class TeacherAvailibilityComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    public dialogRef: MatDialogRef<TeacherAvailibilityComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any,
    private apis: TeacherService,
    private timingService : TimingService,
    private establishmentApis : EstablishmentService,
    private settingServices: SettingsService
  ) { }

days : Day[]
 
  onNoClick(): void {
    this.dialogRef.close();
  }
  periods : Period[];
  teacher : Teacher;
  ngOnInit() {
    console.log(this.teacher)
    console.log(this.data)
    this.timingService.getHiararchyPeriods()
    .subscribe((data : Period[])=>{
      this.periods = data.filter(x=> x.type == 'session')
    })
    this.teacher = this.data.teacher;
    let availibility : NotAvailableTeacher[];
     this.apis.getTeacherAvailibility(this.teacher.id)
    .subscribe((data : NotAvailableTeacher[])=>{
      console.log(data)
      if(data && data.length >0){
        this.data.availibility = data;
      }
      else{
        this.data.availibility = [];
      }
    })

    this.settingServices.getDays()
    .subscribe((data : Day[])=>{
      this.establishmentApis.getEstablishmentSettings()
      .subscribe((establishmentSettings : EstablishmentSetting)=>{
        this.days = data.filter((x : Day)=> establishmentSettings.weekend_days.indexOf(x.id) == -1)
      })
    })
  }


  IsChecked( day_id , session_id){
    if(this.data.availibility){
      if(this.data.availibility.find(x=> x.day_id == day_id && x.period_id == session_id)){
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  }


  checkSessionDay(status , day_id , session_id){
    console.log(status);
    if(status){
      console.log("true")
      if(!this.data.availibility.find(x=> x.day_id == day_id && x.period_id == session_id)){
        let r : NotAvailableTeacher = new NotAvailableTeacher(this.teacher.id);
        r.day_id = day_id;
        r.period_id = session_id;
        this.data.availibility.push(r)
      } 
    }else{
      console.log("false")
     this.data.availibility =  this.data.availibility.filter(x => !(x.day_id == day_id && x.period_id == session_id))
    }
  }
}
